import React, { useMemo } from 'react'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'
import { ShowHero } from '../ShowHero'

export const FeaturedShow: React.FC = () => {
  const { t } = useTranslate('common')

  const featuredProjects = [
    {
      cloudinaryImgPaths: {
        mobile:
          'https://images.angelstudios.com/image/upload/v1731958173/studio-app/catalog/d5eec788-2226-45e4-8156-326d68e07129',
        tablet:
          'https://images.angelstudios.com/image/upload/v1731958153/studio-app/catalog/0ffba4ea-af1e-4555-b589-59d21c27bd7e',
        desktop:
          'https://images.angelstudios.com/image/upload/v1731958145/studio-app/catalog/024fa80e-bb70-4de0-ae90-ff6f1e287555',
      },
      showTitle: t('riotDanceTitle', 'The Riot and the Dance', { ns: 'common' }),
      showDescription: t(
        'riotDanceFeaturedDescription',
        'Discover the beauty of creation through awe-inspiring journeys with Dr. Gordon Wilson.',
      ),
      ctaPath: paths.watch.riotAndTheDanceSeries,
      ctaText: t('watchNow', 'Watch Now', { ns: 'common' }),
      logoImgPath: '/v1667843112/angel-app/riot-and-dance/Riot_and_the_Dance_2x.webp',
    },
    {
      cloudinaryImgPaths: {
        mobile:
          'https://images.angelstudios.com/image/upload/v1715035459/studio-app/catalog/59c6a450-9c52-455e-b398-7e90f5f16ce3',
        tablet:
          'https://images.angelstudios.com/image/upload/v1715035526/studio-app/catalog/f7e4ffa4-b36a-4d0e-b5ec-828dcb1e8aa4',
        desktop:
          'https://images.angelstudios.com/image/upload/v1715035482/studio-app/catalog/0c8a8a16-9a76-4d43-9d11-53ce0a5c6626',
      },
      showTitle: t('tuttleTwins', 'Tuttle Twins', { ns: 'common' }),
      showDescription: t(
        'tuttleTwinsFeaturedDescription',
        'Ethan and Emily Tuttle go on adventures through time to learn about liberty and freedom.',
      ),
      ctaPath: paths.watch.tuttleTwins,
      ctaText: t('watchNow', 'Watch Now', { ns: 'common' }),
      logoImgPath: '/v1723564831/angel-studios/guild/impact/tuttle-twins-white2.webp',
    },
    {
      cloudinaryImgPaths: {
        mobile:
          'https://images.angelstudios.com/image/upload/v1720819669/studio-app/catalog/308f8d97-8fdc-49b3-ad6d-38d2963578ad',
        tablet:
          'https://images.angelstudios.com/image/upload/v1711642426/studio-app/catalog/761f7e71-8044-47cb-8b23-a0794e49a2a3',
        desktop:
          'https://images.angelstudios.com/image/upload/v1711642458/studio-app/catalog/4b038b92-a773-4675-941f-f4db67ea2def',
      },
      showTitle: t('theWingfeatherSaga', 'The Wingfeather Saga', { ns: 'common' }),
      showDescription: t(
        'wingfeatherSagaFeaturedDescription',
        'In a world of wonder, three kids discover a secret that may doom them to a nameless evil.',
      ),
      ctaPath: paths.watch.wingfeatherSaga,
      ctaText: t('watchNow', 'Watch Now', { ns: 'common' }),
      logoImgPath: '/v1723562313/angel-studios/guild/impact/The_Wingfeather_Saga.webp',
    },
    {
      cloudinaryImgPaths: {
        mobile:
          'https://images.angelstudios.com/image/upload/v1730219163/studio-app/catalog/a9d8166b-2c67-4154-846c-faf9bde7bc89',
        tablet:
          'https://images.angelstudios.com/image/upload/v1730219045/studio-app/catalog/90cb825f-38ec-4db6-95b7-113b8e8b3122',
        desktop:
          'https://images.angelstudios.com/image/upload/v1730219055/studio-app/catalog/c332d641-426b-41b4-a985-b314bd1b8ef5',
      },
      showTitle: t('homestead', 'Homestead', { ns: 'common' }),
      showDescription: t(
        'homesteadFeaturedDescription',
        'Survive chaos, defend family, and rediscover life’s roots with Homestead.',
      ),
      ctaPath: paths.watch.homestead,
      ctaText: t('watchNow', 'Watch Now', { ns: 'common' }),
      logoImgPath: '/v1733953586/studio-app/catalog/7c61d65e-1505-4f92-ac23-07c4a81e46ed.webp',
    },
    {
      cloudinaryImgPaths: {
        mobile:
          'https://images.angelstudios.com/image/upload/v1689700598/studio-app/catalog/abaf7017-f5e3-4700-9aa0-5c84e7faaf3e',
        tablet:
          'https://images.angelstudios.com/image/upload/v1689700599/studio-app/catalog/857a0d7a-f64a-44ee-b124-6dfa1a1e2cf4',
        desktop:
          'https://images.angelstudios.com/image/upload/v1689700598/studio-app/catalog/1bee69af-6937-460c-a10e-3c2dcfc08daf',
      },
      showTitle: t('sofTitle', 'Sound of Freedom', { ns: 'common' }),
      showDescription: t(
        'sofFeaturedDescription',
        'Based on the true story of a man who journeys into dark places to rescue a girl from traffickers.',
      ),
      ctaPath: paths.watch.soundOfFreedom,
      ctaText: t('watchNow', 'Watch Now', { ns: 'common' }),
      logoImgPath: '/v1737735441/studio-app/catalog/395156bf-40f6-4aff-8d9f-ccf22348c3a5.webp',
    },
  ]

  const randomIndex = useMemo(() => Math.floor(Math.random() * featuredProjects.length), [featuredProjects.length])
  const selectedProject = featuredProjects[randomIndex]

  if (!selectedProject) {
    return null
  }

  return (
    <ShowHero
      cloudinaryImgPaths={selectedProject.cloudinaryImgPaths}
      imageClassName="rounded-lg bg-cover"
      showTitle={selectedProject.showTitle}
      showDescription={selectedProject.showDescription}
      ctaPath={selectedProject.ctaPath}
      ctaText={selectedProject.ctaText}
      logoImgPath={selectedProject.logoImgPath}
    />
  )
}
